import React from 'react';
import { useLabResultContext } from './lab-result-provider';

export const LabResultDetailsTable: React.FC = () => {
  const { labResult } = useLabResultContext();

  return (
    <div className="w-full shadow-lg rounded-lg p-8">
      <table className="border border-black w-full">
        <tr>
          <th className="p-2 border border-black">Title</th>
          <th className="p-2 border border-black">Code</th>
          <th className="p-2 border border-black">Tube Type</th>
          <th className="p-2 border border-black">Result</th>
        </tr>
        {labResult.resultDetails.map((labResultDetail) => (
          <tr>
            <td className="p-2 border border-black font-bold">{labResultDetail.resultCodeTitle}</td>
            <td className="p-2 border border-black">{labResultDetail.resultCode}</td>
            <td className="p-2 border border-black">{labResultDetail.tubeType}</td>
            <td className="p-2 border border-black">{labResultDetail.result}</td>
          </tr>
        ))}
      </table>
    </div>
  );
};
